
<template>
<v-row justify="center">
  <v-col cols="12" class="tweet_cell">
    <v-row class="tweet_cell_information">
      <v-col cols="2" class="tweet_cell_information-img">
        <img
        :src="tweetInfo.icon_url"
        >
      </v-col>
      <v-col cols="10" class="tweet_cell_information-user-info">
        <p>{{tweetInfo.accountName}}</p>
        <p>@{{tweetInfo.accountId}}</p>
      </v-col>  
    </v-row>
    <v-row class="tweet_cell_content">
      <p>{{tweetInfo.tweet}}</p>
    </v-row>
  </v-col>
</v-row>
</template>

<script>
export default {
  name: 'TweetCell',
  props: ['tweetInfo'],
}
</script>

<style lang="scss" scoped>
.tweet_cell {
  padding: 1px 0 0 0;
}
.tweet_cell_information {
  background-color: white;
  padding: 10px;
  padding-bottom: 0;
}
.tweet_cell_information-img {
  height: 100%;
  padding: 0;
}
.tweet_cell_information-img img {
  border-radius: 50%;
  width:  80%;
}
.tweet_cell_information-user-info {
  height: 100%;
  padding: 0;
}
.tweet_cell_information-user-info p {
  margin: 0;
  margin-left: 5px;
  text-align: left;
  color: #000000;
  font-size: 1.3vw;
  font-weight: bold;
}
.tweet_cell_content {
  background-color: white;
  padding: 20px;
}
.tweet_cell_content p{
  color: #000000;
  font-size: 1.1vw;
  text-align: left;
}

@media screen and (max-width: 768px) {
.tweet_cell_information-user-info p {
  font-size: 3.5vw;
}
.tweet_cell_content p{
  font-size: 3.0vw;
}
}
</style>
